import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";

export function SearchBox({ value, onChange, autoFocus = false, className = "" }) {
  const [text, setText] = useState(value || "");

  useEffect(() => { setText(value || ""); }, [value]);

  useEffect(() => {
    if (text === (value || "")) return undefined;
    const t = setTimeout(() => onChange(text.trim()), 300);
    return () => clearTimeout(t);
  }, [text]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`relative ${className}`} data-testid="search-box">
      <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-400" />
      <input
        data-testid="search-input"
        type="text"
        autoFocus={autoFocus}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") onChange(text.trim()); }}
        placeholder="Search by title, tag or state..."
        className="w-full rounded-full border border-[var(--line)] bg-white py-3 pl-11 pr-11 text-base outline-none transition-colors placeholder:text-stone-400 focus:border-[var(--chakra)] focus:ring-2 focus:ring-[var(--chakra-tint)]"
      />
      {text && (
        <button
          type="button"
          data-testid="search-clear-btn"
          aria-label="Clear search"
          onClick={() => { setText(""); onChange(""); }}
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 text-stone-400 hover:bg-[var(--saffron-tint)] hover:text-[var(--saffron-deep)]"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
